import React, { useState, useContext } from 'react';
import styles from './index.module.scss';
import ShowMoreText from 'react-show-more-text';
import { IEventsList } from '../index';
import { Box, Collapse, Button, IconButton } from '@mui/material';
import classNames from 'classnames';
import { isArray, startCase } from 'lodash';
import DeleteEventAction from './DeleteEventAction';
import EditIcon from '@mui/icons-material/Edit';
import { eventModalContext } from '../../index';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

export default function ContentBox({ event }: { event: IEventsList }) {
  const [showMoreText, setShowMoreText] = useState<boolean>(false);
  const [expand, setExpand] = useState<boolean>(false);
  const { setEventUuid, setEventTab } = useContext(eventModalContext);

  const onClick = () => {
    setShowMoreText(!showMoreText);
  };

  const onExpand = () => {
    setExpand(!expand);
  };

  return (
    <div
      className={classNames(
        styles.content,
        { [styles.expand]: expand },
        'flex flex-col cursor-pointer',
      )}
      onClick={(event) => {
        if (event.target !== event.currentTarget) return;
        onExpand();
      }}
      key={event.name}
    >
      <div
        className="flex flex-row items-center justify-between"
        onClick={onExpand}
      >
        <div className="flex flex-row items-center">
          {event.icon ? <event.icon /> : null}
          <span className={styles.name}>{event.name}</span>
          {event?.circle ? (
            <div
              className={styles.circle}
              style={{
                background: event.circle?.color,
              }}
            >
              {event.circle?.value ?? ''}
            </div>
          ) : null}
        </div>
        {event?.isToShowUpdateIcons && expand ? (
          <div className="flex flex-row">
            {!event?.isToHideEditIcon ? (
              <IconButton
                onClick={() => {
                  setEventUuid(event?.id);
                  setEventTab(event?.tabName);
                }}
              >
                <EditIcon />
              </IconButton>
            ) : null}
            <DeleteEventAction event={event} />
          </div>
        ) : null}
        {expand ? (
          <IconButton
            classes={{
              root: 'p-0',
            }}
            onClick={onExpand}
          >
            <CloseFullscreenIcon className={styles.closeIcon} />
          </IconButton>
        ) : null}
      </div>
      {expand ? (
        <Box>
          <Collapse in={true}>
            <div className="flex flex-col">
              {isArray(event?.description) ? (
                <div className={styles.descriptionContent}>
                  {(event?.description ?? [])?.map((x, index) => (
                    <div key={index} className="flex flex-col">
                      <span className={styles.label}>{startCase(x.name)}</span>
                      <ShowMoreText
                        lines={4}
                        more={<div className={styles.expandText}>Read more</div>}
                        less={<div className={styles.expandText}>Read less</div>}
                        onClick={onClick}
                        expanded={showMoreText}
                        className={classNames(styles.description, 'cursor-default')}
                        truncatedEndingComponent={''}
                        keepNewLines={true}
                      >
                        {x.description ?? ''}
                      </ShowMoreText>
                    </div>
                  ))}
                </div>
              ) : (
                <ShowMoreText
                  lines={4}
                  more={<div className={styles.expandText}>Read more</div>}
                  less={<div className={styles.expandText}>Read less</div>}
                  onClick={onClick}
                  expanded={showMoreText}
                  className={classNames(styles.description, 'cursor-default')}
                  truncatedEndingComponent={''}
                  keepNewLines={true}
                >
                  {event.description ?? ''}
                </ShowMoreText>
              )}
              {event?.cta && event?.ctaText ? (
                <Button
                  variant="contained"
                  color="primary"
                  classes={{ root: styles.btn }}
                  onClick={() => {
                    event.cta?.();
                  }}
                >
                  {event.ctaText}
                </Button>
              ) : null}
            </div>
          </Collapse>
        </Box>
      ) : null}
    </div>
  );
}
